module.exports = __webpack_public_path__ + "img/dsnjj.e8b0aaa5.png";